export default {
    routerName: '画像詳細',
    pic: {
        name: '画像名',
        thumb: 'サムネイル',
        image: '画像',
        status: '状態',
        open: '有効',
        close: '無効',
        description: '記述',
        sortOrder: 'ソート',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
    },
};
